import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260108_export_permissions_role_based",
  description: "Convert exportPermissions from boolean keys to role-based enum values (ALLOW/DENY/IF_ASSIGNED)",
  apply(json: any) {
    // Migration mapping from old keys to new role names
    const roleMapping = {
      sales_manager: "Sales Manager",
      sales_team_lead: "Sales Team Lead",
      sales_agent: "Sales Agent",
    };

    // Roles that require assignment when permission is granted
    const requiresAssignment = new Set(["sales_team_lead", "sales_agent"]);

    if (!json.planSetTemplates) {
      return json;
    }

    for (const templateId in json.planSetTemplates) {
      const template = json.planSetTemplates[templateId];

      if (!template.exportPermissions) {
        continue;
      }

      const newPermissions: { [roleName: string]: string } = {};

      for (const oldKey in roleMapping) {
        const newKey = roleMapping[oldKey as keyof typeof roleMapping];
        const oldValue = template.exportPermissions[oldKey];

        if (oldValue === true) {
          // If true, use IF_ASSIGNED for roles that require assignment, ALLOW for others
          newPermissions[newKey] = requiresAssignment.has(oldKey) ? "IF_ASSIGNED" : "ALLOW";
        }
      }

      template.exportPermissions = newPermissions;
    }

    return json;
  },
};

export default migration;
